import { Component, ContentChild, Input, OnChanges, OnInit, SimpleChanges, TemplateRef } from '@angular/core';
import {
  addDays,
  differenceInCalendarMonths,
  format,
  getDate,
  getDay,
  getMonth,
  getWeek,
  getWeeksInMonth,
  isBefore,
  isPast,
  isSameMonth,
  isToday,
  setDate,
  startOfToday,
  startOfWeek,
} from 'date-fns';

export interface IDate {
  value: Date;
  date: number;
  day: number;
  week: number;
  month: number;
  isToday: boolean;
  isPastDate: boolean;
  isSameMonth: boolean;
  formatValue?: string;
  // isPastMonth: boolean;
  // isFutureMonth: boolean;
}

type WeekStartsOn = 0 | 1 | 2 | 3 | 4 | 5 | 6;

/**
 * 本组件用于替换原来的 calendar 基础组件
 *
 * 本组件仅提供基础的日历功能，样式和其他功能相关需在此基础上再次封装
 */
@Component({
  selector: 'v4-widget-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss'],
})
export class V4CalendarComponent implements OnInit, OnChanges {
  @ContentChild('monthBar') monthBar: TemplateRef<any>;
  @ContentChild('weekCell') weekCell: TemplateRef<any>;
  @ContentChild('dateCell') dateCell: TemplateRef<any>;
  /**
   * 根据传的日期生成日历
   */
  @Input() date: Date = new Date();
  listOfDate: IDate[] = [];
  readonly listOfWeekname = [0, 1, 2, 3, 4, 5, 6];
  constructor() {}

  ngOnInit() {
    this.listOfDate = this.buildCalendarDates(this.date);
    console.log('dates: ', this.listOfDate);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['date'] && changes['date'].currentValue) {
      this.listOfDate = this.buildCalendarDates(this.date);
      console.log('dates: ', this.listOfDate);
    }
  }

  private buildCalendarDates(month: Date): IDate[] {
    const dates = [];

    // 获取月份的第一天
    const firstDayOfMonth = setDate(month, 1);

    // 获取这个月的第一个星期天
    // 这里默认周日为一周的第一天，如果需要修改，可以使用 weekStartsOn 参数
    const firstSundayOfMonth = startOfWeek(firstDayOfMonth, {
      weekStartsOn: this.listOfWeekname[0] as WeekStartsOn,
    });

    // 该月一共有几周
    const weeks = getWeeksInMonth(month);

    for (let index = 0; index < weeks * 7; index++) {
      const day = addDays(firstSundayOfMonth, index);
      dates.push(this.buildDate(day));
    }

    // for (let w = 0; w < weeks; w++) {
    //   const firstDayOfWeek = addWeeks(firstSundayOfMonth, w);
    //   for (let i = 0; i < this.listOfWeekname.length; i++) {
    //     const day = addDays(firstDayOfWeek, i);
    //     dates.push(this.buildDate(day));
    //   }
    // }

    return dates;
  }

  private buildDate(date: Date): IDate {
    return {
      value: date,
      date: getDate(date),
      day: getDay(date),
      week: getWeek(date),
      month: getMonth(date),
      isToday: isToday(date),
      isPastDate: isBefore(date, startOfToday()),
      isSameMonth: isSameMonth(date, this.date),
      formatValue: format(date, 'yyyy-MM-dd'),
      // isPastMonth: differenceInCalendarMonths(date, this.date) < 0,
      // isFutureMonth: differenceInCalendarMonths(date, this.date) > 0,
    };
  }
}
